// Platform Compliance Center (admin-portal). Platform staff manage the
// tenant-agnostic legal documents every company + employee accepts, and see
// platform-wide adoption. All calls go through the gateway to compliance-service
// (kp-compliance-dev) on its platform-scoped routes (null tenant tolerated, gated
// to platform roles). The global axios interceptor attaches the admin token.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface LegalVersion {
  id: string;
  doc_type: string;
  version: number;
  language: string;
  title: string;
  summary?: string;
  status: string;
  publish_date?: string;
  effective_date?: string;
  created_at: string;
}

export interface LegalDocument {
  doc_type: string;
  title: string;
  required: boolean;
  current_version: number;
  versions: LegalVersion[];
}

export interface AcceptanceSummary {
  doc_type: string;
  title: string;
  version: number;
  accepted_count: number;
  tenant_count?: number;
}

export interface PublishVersionInput {
  title: string;
  body: string;
  summary?: string;
  language?: string;
  required?: boolean;
  effective_date?: string | null;
}

export const getPlatformDocuments = () =>
  axios
    .get<{ documents: LegalDocument[] | null }>(`${API_V1}/compliance/platform/documents`)
    .then((r) => r.data.documents ?? []);

export const getPlatformSummary = () =>
  axios
    .get<{ summary: AcceptanceSummary[] | null }>(
      `${API_V1}/compliance/platform/acceptances/summary`,
    )
    .then((r) => r.data.summary ?? []);

export const publishVersion = (docType: string, body: PublishVersionInput) =>
  axios
    .post(`${API_V1}/compliance/platform/documents/${docType}/versions`, body)
    .then((r) => r.data);
